export function getNameMonph(numeroMes: number): string {
  if (numeroMes < 1 || numeroMes > 12) {
    return 'Mês inválido';
  }

  const meses = [
    'JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO',
    'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'
  ];

  return meses[numeroMes - 1];
}
